

import React, { useEffect, useState, useRef } from 'react'
import '../css/viewGame1.css'
import '../css/layout.css'
import axios from 'axios'
import { useHistory, useLocation } from 'react-router-dom'
import Header from '../Components/Header'
import css from '../css/Pan.module.css'
import Rightcontainer from '../Components/Rightcontainer'
import Swal from 'sweetalert2'
import '../css/Loader.css'
import io from '../Components/socket'
import Compressor from 'compressorjs'
import socket from '../Components/socket'
import { addResponseMessage } from 'react-chat-widget'

export default function ViewGame1(props) {
  const history = useHistory();


  const location = useLocation();
  const path = location.pathname.split('/')[2];

  const [Game, setGame] = useState(null);
  const [status, setStatus] = useState(null);
  const [fecthStatus, setFecthStatus] = useState(null);
  const [scrnshot, setScrnshot] = useState(null);
  const [scrnshot1, setScrnshot1] = useState('');
  const [roomcode, setRoomcode] = useState('');
  const [reason, setReason] = useState('');
  const [userAllData, setUserAllData] = useState(null);
  const [user, setUser] = useState(null);
  const [submitProcess, setProcess] = useState(true);
  const [secondsRemaining, setSecondsRemaining] = useState(240);
  const [isTimedOut, setIsTimedOut] = useState(false);
  const [settingData, setSettingData] = useState('')
  // console.log(settingData, "settingData")

  const submitReq = useRef(false);

  useEffect(() => {
    socket.emit('websetting', '');
  }, []);
  useEffect(() => {
    socket.on("websettingGet", (data) => {
      localStorage.setItem("sitSetting", JSON.stringify(data));
      setSettingData(data);
    });

    socket.on("recive-msg", (msgs) => {
      if (msgs?.sender !== user?._id) addResponseMessage(msgs.text);
    });
  }, [user]);
  const role = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      history.push('/login');
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const res = await axios.get(`https://api.kakaking.in/me`, { headers });
      setUser(res.data._id);
      setUserAllData(res.data);
      fetchGameDetails(res.data._id);
    } catch (e) {
      if (e.response?.status === 401) handleLogout();
    }
  };

  const fetchGameDetails = async (userId) => {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const res = await axios.get(`https://api.kakaking.in/challange/${path}`, { headers });
      const gameData = res.data;
      setGame(gameData);

      if (gameData.Status === 'new' || gameData.Status === 'requested') {
        setTimeout(() => history.push(props.location.state?.prevPath || '/'), 5000);
      } else {
        setProcess(false);
      }

      if (userId === gameData.Accepetd_By?._id) setFecthStatus(gameData.Acceptor_status);
      if (userId === gameData.Created_by?._id) setFecthStatus(gameData.Creator_Status);

    } catch (e) {
      console.error(e);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.reload();
    history.push('/login');
  };

  useEffect(() => {
    if (!Game?.createdAt || (Game.Room_code && Game.Room_code !== '0')) return;

    const timer = setInterval(() => {
      const diff = Math.floor((new Date().getTime() - new Date(Game.createdAt).getTime()) / 1000);
      const remaining = 540 - diff;

      if (remaining <= 0) {
        setSecondsRemaining(0);
        setIsTimedOut(true);
        clearInterval(timer);
      } else {
        setSecondsRemaining(remaining);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [Game]);

  useEffect(() => { role(); }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setScrnshot1(URL.createObjectURL(file));

    if (file.size / 1024 > 300) {
      new Compressor(file, {
        quality: 0.6,
        success(result) { setScrnshot(result); },
      });
    } else {
      setScrnshot(file);
    }
  };

  const submitRoomCode = async () => {
    if (isTimedOut) return Swal.fire("Expired", "Time is up! Please cancel the match.", "error");

    if (!/^[0-9]{8}$/.test(roomcode) || roomcode[0] !== '0') {
      return Swal.fire("Invalid Code", "Enter an 8-digit code starting with 0", "error");
    }
    const token = localStorage.getItem('token');
    try {
      await axios.patch(`https://api.kakaking.in/challange/roomcode/${path}`,
        { Room_code: roomcode },
        { headers: { Authorization: `Bearer ${token}` } });
      window.location.reload();
    } catch (e) {
      Swal.fire("Error", "Could not set room code", "error");
    }
  };

  const submitAutoRoomCode = async () => {
    if (isTimedOut) return Swal.fire("Expired", "Time is up! Please cancel the match.", "error");

    if (!/^[0-9]{8}$/.test(roomcode) || roomcode[0] !== '0') {
      return Swal.fire("Invalid Code", "Enter an 8-digit code starting with 0", "error");
    }
    const token = localStorage.getItem('token');
    try {
      await axios.patch(`https://api.kakaking.in/challange/autoroomcode/${path}`,
        { Room_code: roomcode },
        { headers: { Authorization: `Bearer ${token}` } });
      window.location.reload();
    } catch (e) {
      Swal.fire("Error", "Could not set room code", "error");
    }
  };

  const handleResultSubmit = async (e) => {
    e.preventDefault();
    if (submitReq.current) return;
    if (!status) return Swal.fire("Wait", "Please select a game result", "warning");
    if (status === 'winn' && !scrnshot) return Swal.fire("Wait", "Please upload winning screenshot", "warning");
    if (status === 'cancelled' && !reason) return Swal.fire("Wait", "Please select a reason for cancellation", "warning");

    submitReq.current = true;
    setProcess(true);

    const formData = new FormData();
    formData.append('file', scrnshot);
    formData.append('status', status);
    if (status === 'cancelled') formData.append('reason', reason);

    try {
      const token = localStorage.getItem('token');
      await axios.post(`https://api.kakaking.in/challange/result/${path}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      history.push(props.location.state?.prevPath || '/');
    } catch (error) {
      submitReq.current = false;
      setProcess(false);
      Swal.fire("Error", "Failed to update result", "error");
    }
  };


  const handleAutoResultSubmit = async (e) => {
    e.preventDefault();
    if (submitReq.current) return;
    if (status === 'cancelled' && !reason) return Swal.fire("Wait", "Please select a reason for cancellation", "warning");

    submitReq.current = true;
    setProcess(true);

    const formData = new FormData();
    formData.append('file', scrnshot);
    formData.append('status', status);
    if (status === 'cancelled') formData.append('reason', reason);

    try {
      const token = localStorage.getItem('token');
      await axios.post(`https://api.kakaking.in/challange/result-auto/${path}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      history.push(props.location.state?.prevPath || '/');
    } catch (error) {
      submitReq.current = false;
      setProcess(false);
      Swal.fire("Error", "Failed to update result", "error");
    }
  };

  if (!Game) return (
    <div className="loading-screen">
      <div className="spinner-border text-primary" role="status"></div>
    </div>
  );

  return (
    <div className="game-page-container">
      <Header user={userAllData} />

      <main className="game-content">
        <div className="content-inner">

          {/* Battle Header Card */}
          <div className="ui-card battle-card">
            <div className="players-vs-row">
              <div className="player-col">
                <div className="avatar-box p1-border">
                  <img src={Game?.Created_by?.avatar ? `https://api.kakaking.in/${Game.Created_by.avatar}` : "/images/avatars/Avatar1.png"} alt="P1" />
                </div>
                <span className="player-name">{Game?.Created_by?.Name || 'Player 1'}</span>
              </div>

              <div className="vs-center">
                <div className="vs-badge">VS</div>
                <div className="amount-tag">₹{Game?.Game_Ammount}</div>
              </div>

              <div className="player-col">
                <div className="avatar-box p2-border">
                  <img src={Game?.Accepetd_By?.avatar ? `https://api.kakaking.in/${Game.Accepetd_By.avatar}` : "/images/avatars/Avatar2.png"} alt="P2" />
                </div>
                <span className="player-name">{Game?.Accepetd_By?.Name || 'Player 2'}</span>
              </div>
            </div>
          </div>

          {/* Room Code Section */}
          <div className="ui-card action-card">
            <div className="card-title">Room Code</div>
            {Game.Room_code && Game.Room_code !== '0' ? (
              <div className="room-display-area">
                <div className="room-number">{Game.Room_code}</div>
                <button className="update-btn" onClick={() => { navigator.clipboard.writeText(Game.Room_code); Swal.fire({ title: 'Copied!', timer: 800, icon: 'success' }); }}>
                  <i className="far fa-copy "></i> Copy Code
                </button>
              </div>
            ) : isTimedOut ? (
              <div className="timeout-area">
                <div className="timeout-icon">⚠️</div>
                <p className="timeout-title">Time Expired!</p>
                <p className="timeout-sub">Room code wasn't set in time. Both players should <b>Cancel</b> the match below.</p>
              </div>
            ) : (
              user === Game.Created_by?._id ? (
                <div className="room-input-area">
                  <input type="number" className="room-input" placeholder="Enter Room Code" value={roomcode} onChange={(e) => setRoomcode(e.target.value)} />
                  {settingData?.isGameRules === true ? <button className="update-btn" onClick={submitAutoRoomCode}>Update Auto Code</button> : <button className="update-btn" onClick={submitRoomCode}>Update Code</button>}
                  <p className="timer-text">Time Left: <span className="text-danger">{secondsRemaining}s</span></p>
                </div>
              ) : (
                <div className="waiting-area">
                  <div className="loading-spinner"></div>
                  <p className="wait-title">Waiting for Opponent...</p>
                  <p className="wait-sub">Host has <span className="text-danger">{secondsRemaining}s</span> to set the code.</p>
                </div>
              )
            )}
          </div>

          {/* Result Section */}

          {settingData?.isFairPlay === true ? <div className="ui-card result-card">
            <div className="card-title">Match Auto Result</div>

            {fecthStatus ? (
              <div className="already-submitted">
                <div className="status-label">{fecthStatus.toUpperCase()}</div>
                <p>Result already submitted</p>
              </div>
            ) : (
              <form onSubmit={handleAutoResultSubmit}>
                <div className="result-options">
                  <div className={`opt-box ${status === 'winn' ? 'active-win' : ''}`} onClick={() => !isTimedOut && setStatus('winn')}>
                    <div className="opt-icon win">🏆</div>
                    <span>I Won</span>
                  </div>
                  <div className={`opt-box ${status === 'lose' ? 'active-lose' : ''}`} onClick={() => !isTimedOut && setStatus('lose')}>
                    <div className="opt-icon lose">😞</div>
                    <span>I Lost</span>
                  </div>
                  <div className={`opt-box ${status === 'cancelled' ? 'active-cancel' : ''}`} onClick={() => setStatus('cancelled')}>
                    <div className="opt-icon cancel">✕</div>
                    <span>Cancel</span>
                  </div>
                </div>

                {status === 'winn' && (
                  <div className="upload-section" style={{ padding: "10px" }}>
                    {/* {scrnshot1 && <img src={scrnshot1} className="img-preview" alt="Preview" />} */}
                     {scrnshot1 && (
  <img
    src={scrnshot1}
    alt="Preview"
    style={{
      width: "100%",
      maxWidth: "200px",   // mobile पर ज्यादा से ज्यादा 200px
      height: "auto",
      objectFit: "contain",
      borderRadius: "8px",
      marginTop: "10px"
    }}
  />
)}
                    <input type="file" className="file-input" accept="image/*" onChange={handleImageChange} />
                    <p className="upload-hint">Upload winning screenshot</p>
                  </div>
                )}

                {status === 'cancelled' && (
                  <select className="reason-select" style={{ padding: "10px" }} value={reason} onChange={(e) => setReason(e.target.value)} required>
                    <option value="">-- Choose Reason --</option>
                    {isTimedOut && <option value="Time Expired">Time Expired (Code not set)</option>}
                    <option value="Opponent not joining">Opponent not joining</option>
                    <option value="Game not started">Game not started</option>
                    <option value="Wrong Room Code">Wrong Room Code</option>
                    <option value="Opponent disconnected">Opponent disconnected</option>
                  </select>
                )}

                <button type="submit" className="submit-result-btn" disabled={submitProcess}>
                  {submitProcess ? 'Processing...' : 'Submit Result'}
                </button>
              </form>
            )}
          </div> : <div className="ui-card result-card">
            <div className="card-title">Match Manual Result</div>

            {fecthStatus ? (
              <div className="already-submitted">
                <div className="status-label">{fecthStatus.toUpperCase()}</div>
                <p>Result already submitted</p>
              </div>
            ) : (
              <form onSubmit={handleResultSubmit}>
                <div className="result-options">
                  <div className={`opt-box ${status === 'winn' ? 'active-win' : ''}`} onClick={() => !isTimedOut && setStatus('winn')}>
                    <div className="opt-icon win">🏆</div>
                    <span>I Won</span>
                  </div>
                  <div className={`opt-box ${status === 'lose' ? 'active-lose' : ''}`} onClick={() => !isTimedOut && setStatus('lose')}>
                    <div className="opt-icon lose">😞</div>
                    <span>I Lost</span>
                  </div>
                  <div className={`opt-box ${status === 'cancelled' ? 'active-cancel' : ''}`} onClick={() => setStatus('cancelled')}>
                    <div className="opt-icon cancel">✕</div>
                    <span>Cancel</span>
                  </div>
                </div>

                {status === 'winn' && (
                  <div className="upload-section" style={{ padding: "10px" }}>
                    {/* {scrnshot1 && <img src={scrnshot1} className="img-preview" alt="Preview" />} */}
                     {scrnshot1 && (
  <img
    src={scrnshot1}
    alt="Preview"
    style={{
      width: "100%",
      maxWidth: "200px",   // mobile पर ज्यादा से ज्यादा 200px
      height: "auto",
      objectFit: "contain",
      borderRadius: "8px",
      marginTop: "10px"
    }}
  />
)}
                    <input type="file" className="file-input" accept="image/*" onChange={handleImageChange} />
                    <p className="upload-hint">Upload winning screenshot</p>
                  </div>
                )}

                {status === 'cancelled' && (
                  <select className="reason-select" style={{ padding: "10px" }} value={reason} onChange={(e) => setReason(e.target.value)} required>
                    <option value="">-- Choose Reason --</option>
                    {isTimedOut && <option value="Time Expired">Time Expired (Code not set)</option>}
                    <option value="Opponent not joining">Opponent not joining</option>
                    <option value="Game not started">Game not started</option>
                    <option value="Wrong Room Code">Wrong Room Code</option>
                    <option value="Opponent disconnected">Opponent disconnected</option>
                  </select>
                )}

                <button type="submit" className="submit-result-btn" disabled={submitProcess}>
                  {submitProcess ? 'Processing...' : 'Submit Result'}
                </button>
              </form>
            )}
          </div>}



        </div>
      </main>

      <style>{`
                .game-page-container { background: #f8f9fa; min-height: 100vh; display: flex; flex-direction: column; }
                .game-content { flex: 1; padding: 15px; padding-bottom: 80px; margin-top: 90px; }
                .content-inner { max-width: 500px; margin: 0 auto; }
                .ui-card { background: #fff; border-radius: 12px; padding: 15px; margin-bottom: 15px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); border: 1px solid #eee; }
                .card-title { font-weight: 700; font-size: 1rem; margin-bottom: 15px; color: #333; border-bottom: 1px solid #f0f0f0; padding-bottom: 8px; }

                /* Battle Card */
                .players-vs-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; }
                .player-col { flex: 1; text-align: center; }
                .avatar-box { width: 65px; height: 65px; margin: 0 auto 8px; border-radius: 50%; padding: 3px; }
                .avatar-box img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
                .p1-border { border: 2px solid #007bff; }
                .p2-border { border: 2px solid #dc3545; }
                .player-name { font-size: 0.8rem; font-weight: 700; display: block; }
                .vs-badge { font-weight: 900; font-style: italic; font-size: 1.4rem; color: #ff4d4d; }
                .amount-tag { background: #e7f9ed; color: #28a745; font-weight: 700; padding: 2px 8px; border-radius: 12px; font-size: 0.9rem; margin-top: 5px; display: inline-block; }

                /* Room Code & Timeout */
                .room-number { font-size: 2rem; font-weight: 800; color: #007bff; text-align: center; }
                .room-input { width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; text-align: center; font-size: 1.2rem; font-weight: 700; margin-bottom: 10px; }
                .update-btn { background: #00c853; color: white; border: none; padding: 12px; border-radius: 8px; width: 100%; font-weight: 700; }
                .timeout-area { text-align: center; padding: 10px; background: #fff5f5; border-radius: 8px; border: 1px solid #feb2b2; }
                .timeout-icon { font-size: 2rem; }
                .timeout-title { font-weight: 800; color: #c53030; margin-top: 5px; }
                .timeout-sub { font-size: 0.85rem; color: #742a2a; }

                /* Result Options */
                .result-options { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin-bottom: 20px; }
                .opt-box { background: #fcfcfc; border: 2px solid #eee; border-radius: 12px; padding: 12px 5px; text-align: center; cursor: pointer; transition: 0.2s; }
                .active-win { border-color: #ffc107; background: #fffdf5; }
                .active-lose { border-color: #6c757d; background: #f8f9fa; }
                .active-cancel { border-color: #ff4d4d; background: #fff5f5; }
                
                .submit-result-btn { background: #007bff; color: white; border: none; padding: 14px; border-radius: 8px; width: 100%; font-weight: 700; margin-top: 10px; }
                .loading-screen { height: 100vh; display: flex; align-items: center; justify-content: center; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                .loading-spinner { width: 30px; height: 30px; border: 3px solid #f3f3f3; border-top: 3px solid #007bff; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 10px; }
            `}</style>
    </div>
  );
}


